import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import AdvancedSearchHelper from '../../AdvancedSearchHelper';
import {
  limitSelectOptions,
  casefoldersSelectOptions,
  querySelectOptions,
  regionSelectOptions,
  chapterSelectOptions,
  caseTypeSelectOptions,
  industrySelectOptions,
  assetsLiabilitiesSelectOptions,
} from '../../formData';
import FieldSet from '../../../Modules/FieldSet';
import {
  SearchPDFsField,
  CasesField,
  RegionField,
  QueryField,
  CaseTitlesField,
  ChapterField,
  TypeField,
  DatePickerField,
  BusinessOnlyField,
  IndustryField,
  AssetsField,
  LiabilitiesField,
  InputField,
} from '../../fields';

import '../../AdvancedSearch.less';

const GeneralForm = ({ filter, onSubmit, onReset }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={filter}
    render={({ handleSubmit, form }) => (
      <form onSubmit={handleSubmit} className="advanced-search-form">
        <InputField placeholder="Enter Keywords" />
        <AdvancedSearchHelper />
        <div className="advanced-search-filters">
          <FieldSet title="Advanced Filters">
            <div className="form-item form-item-row">
              <div className="col-2">
                <SearchPDFsField limitSelectOptions={limitSelectOptions} />
              </div>
              <div className="col-2">
                <CasesField casefoldersSelectOptions={casefoldersSelectOptions} />
              </div>
            </div>
          </FieldSet>
          <FieldSet title="Case Information">
            <div className="form-item form-item-row">
              <div className="col-2">
                <RegionField regionSelectOptions={regionSelectOptions} />
              </div>
              <div className="col-2">
                <QueryField querySelectOptions={querySelectOptions} />
              </div>
            </div>
            <div className="form-item form-item-row">
              <div className="col-2">
                <ChapterField chapterSelectOptions={chapterSelectOptions} />
              </div>
              <div className="col-2">
                <TypeField caseTypeSelectOptions={caseTypeSelectOptions} />
              </div>
            </div>
            <div className="form-item form-item-row">
              <div className="col-2">
                <CaseTitlesField limitSelectOptions={limitSelectOptions} />
              </div>
            </div>
          </FieldSet>
          <FieldSet title="Financial Filters">
            <div className="form-item form-item-row">
              <div className="col-2">
                <BusinessOnlyField limitSelectOptions={limitSelectOptions} />
              </div>
              <div className="col-2">
                <IndustryField industrySelectOptions={industrySelectOptions} />
              </div>
            </div>
            <div className="form-item form-item-row">
              <div className="col-2">
                <AssetsField assetsLiabilitiesSelectOptions={assetsLiabilitiesSelectOptions} />
              </div>
              <div className="col-2">
                <LiabilitiesField assetsLiabilitiesSelectOptions={assetsLiabilitiesSelectOptions} />
              </div>
            </div>
          </FieldSet>
          <FieldSet title="Date Filters">
            <div className="form-item">
              <label>Cases filed</label>
              <div className="form-item-row">
                <DatePickerField fieldName="date_filed_from" placeholderText="From" />
                <DatePickerField fieldName="date_filed_to" placeholderText="Through" />
              </div>
            </div>
            <div className="form-item">
              <label>Cases closed</label>
              <div className="form-item-row">
                <DatePickerField fieldName="date_closed_from" placeholderText="From" />
                <DatePickerField fieldName="date_closed_to" placeholderText="Through" />
              </div>
            </div>
            <div className="form-item">
              <label>Cases dismissed</label>
              <div className="form-item-row">
                <DatePickerField fieldName="date_dismissed_from" placeholderText="From" />
                <DatePickerField fieldName="date_dismissed_to" placeholderText="Through" />
              </div>
            </div>
            <div className="form-item">
              <label>Cases discharged</label>
              <div className="form-item-row">
                <DatePickerField fieldName="date_discharged_from" placeholderText="From" />
                <DatePickerField fieldName="date_discharged_to" placeholderText="Through" />
              </div>
            </div>
            <div className="form-item">
              <label>Documents filed</label>
              <div className="form-item-row">
                <DatePickerField fieldName="date_doc_filed_from" placeholderText="From" />
                <DatePickerField fieldName="date_doc_filed_to" placeholderText="Through" />
              </div>
            </div>
          </FieldSet>
        </div>
        <div className="action-btn-container">
          <button type="submit" className="btn btn-success btn-search">
            Search
          </button>
          <button
            type="button"
            className="btn btn-link"
            onClick={() => {
              form.reset();
              onReset();
            }}
          >
            Clear
          </button>
        </div>
      </form>
    )}
  />
);

GeneralForm.propTypes = {
  filter: PropTypes.any.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

export default GeneralForm;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/initialForms/bankruptcy/GeneralForm.jsx